import React from 'react';
import { Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import { SessionProvider } from './hooks/useSession';
import { ToastProvider } from './hooks/useToast';
import { AlertProvider } from './hooks/useAlert';

import { Routes } from './routes/index';
import history from './utils/history';

import { GlobalStyle } from "./styles/global";
import { AuthProvider } from './hooks/useAuth';
import { apolloClient } from './services/apolloClient';

require('dotenv').config();

export const App: React.FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <SessionProvider>
        <ToastProvider>
          <AuthProvider>
            <AlertProvider>
              <GlobalStyle/>
                <Router history={history}>
                  <Routes/>
                </Router>
            </AlertProvider>
          </AuthProvider>
        </ToastProvider>        
      </SessionProvider>
    </ApolloProvider>
  );
}

export default App;
